(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bliss-lubricant-offer"] && !Shopify.designMode) return;
  try {
    (function () {
  function activateBundle() {
    document.querySelectorAll('[data-bliss-set-2026]').forEach(function (root) {
      if (root.dataset.bundleReady === 'yes') return;
      root.dataset.bundleReady = 'yes';
      var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      var extras = Array.from(root.querySelectorAll('[data-set-addon]'));
      var main = root.querySelector('[data-set-main-variant]');
      var mainPrice = root.querySelector('[data-set-main-price]');
      var addonTotal = root.querySelector('[data-set-addon-total]');
      var total = root.querySelector('[data-set-total]');
      var button = root.querySelector('[data-set-add]');
      var error = root.querySelector('[data-set-error]');
      var limit = Number(root.dataset.minimum || 7500);
      var cap = Number(root.dataset.priceCap || 7500);
      var money = function (cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:root.dataset.currency||'USD'}).format(cents / 100);
      };
      var busy = false;
      function currentOption(input) {
        return input.tagName === 'SELECT' ? input.options[input.selectedIndex] : input;
      }
      function chosen() {
        return extras.filter(function (item) {
          return item.querySelector('[data-set-checkbox]').checked;
        });
      }
      function selectedPrice(item) {
        return Number(item.dataset.price || 0);
      }
      function refresh() {
        var selected = chosen();
        var mp = Number(currentOption(main).dataset.price || 0);
        var ap = selected.reduce(function (sum, item) {return sum+selectedPrice(item);}, 0);
        var subtotal = mp + ap;
        root.hidden = mp >= cap;
        root.classList.toggle('is-eligible', selected.length > 0 && subtotal >= limit);
        mainPrice.textContent = money(mp);
        addonTotal.textContent = money(ap);
        total.textContent = money(subtotal);
        extras.forEach(function (item) {
          item.classList.toggle('is-selected',item.querySelector('[data-set-checkbox]').checked);
        });
        button.disabled = busy || selected.length === 0;
        button.textContent = busy ? 'Adding…' : (selected.length ? 'Add bundle to cart' : 'Select an add-on');
      }
      extras.forEach(function (item) {
        item.querySelector('[data-set-checkbox]').addEventListener('change',refresh);
        var picker = item.querySelector('[data-set-variant]');
        if (picker.tagName === 'SELECT') {
          picker.addEventListener('change',function () {
            var v=currentOption(picker);
            item.dataset.price=v.dataset.price||'0';
            item.querySelector('[data-set-price]').textContent=money(Number(item.dataset.price));
            var compare=Number(v.dataset.compare||0);
            var crossed=item.querySelector('[data-set-compare]');
            crossed.hidden=!(compare>Number(item.dataset.price));
            crossed.textContent=crossed.hidden?'':money(compare);
            refresh();
          });
        }
      });
      main.addEventListener('change',refresh);
      button.addEventListener('click',function () {
        if (busy || !chosen().length) return;
        busy=true;
        error.hidden=true;
        refresh();
        fetch(base+'cart.js',{credentials:'same-origin'})
          .then(function (response) {if(!response.ok) throw new Error('Unable to load cart.');return response.json();})
          .then(function (cart) {
            var mainId=Number(main.value);
            var alreadyInCart=cart.items.some(function (item) {return Number(item.variant_id)===mainId;});
            var lines=chosen().map(function (item) {
              return {id:Number(item.querySelector('[data-set-variant]').value),quantity:1};
            });
            if(!alreadyInCart) lines.unshift({id:mainId,quantity:1});
            return fetch(base+'cart/add.js',{
              method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
              body:JSON.stringify({items:lines})
            }).then(function (response) {
              if(!response.ok) return response.json().then(function (data) {throw new Error(data.description||'Could not add bundle.');});
              return fetch(base+'cart.js',{credentials:'same-origin'});
            });
          })
          .then(function (response) {if(!response.ok)throw new Error('Unable to check cart.');return response.json();})
          .then(function (cart) {
            if(Number(cart.original_total_price||0)>=limit) {
              window.location.assign(base+'discount/BLISSENTRY?redirect='+encodeURIComponent(base+'cart'));
            } else {
              window.location.assign(base+'cart');
            }
          })
          .catch(function (issue) {
            error.textContent=issue&&issue.message?issue.message:'Could not add your selection. Please try again.';
            error.hidden=false;
            busy=false;
            refresh();
          });
      });
      refresh();
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',activateBundle);
  else activateBundle();
  document.addEventListener('shopify:section:load',activateBundle);
}());
  } catch(e) { console.error(e); }
})();

})();
